import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'shared/lib';

import { getRemainingSeconds, getScenario, tick } from 'entities/scenario';

export const useStartTimerTick = () => {
  const dispatch = useAppDispatch();
  const remaining = useAppSelector(getRemainingSeconds);
  const currentStep = useAppSelector(getScenario)?.step;

  useEffect(() => {
    if (remaining <= 0 || !currentStep) {
      return;
    }

    const id = setInterval(() => {
      if (remaining <= 0) {
        clearInterval(id);
        return;
      }
      dispatch(tick(currentStep));
    }, 1_000);

    return () => clearInterval(id);
  }, [currentStep, dispatch, remaining]);
};
